<template>
  <v-container ref="barWrapper" fluid fill-height class="back" ma-0 pa-1 >
    <v-layout column fill-height  justify-start>
      <loading-circle
          :show="loader"
        />
      <v-toolbar color="secondary" dense>
        <v-toolbar-title>
          <span v-if="mode == 'create'" class="body-1 uppercase white--text">{{ $t('new event for') }} {{ data.name }}</span>
          <span v-else class="body-1 uppercase white--text">{{ $t('event') }} {{ data.users_name }}</span>
        </v-toolbar-title>

        <v-layout fill-height justify-end>
          <v-tooltip v-if="mode == 'create'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'createEvent'" v-if="mode == 'create'" icon flat slot="activator" @click="createEvent">
              <v-icon color="white">done</v-icon>
            </v-btn>
            <span>{{ $t('create') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode == 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'updateEvent'" v-if="mode == 'edit'" icon flat slot="activator" @click="updateEvent">
              <v-icon color="white">done</v-icon>
            </v-btn>
            <span>{{ $t('save') }}</span>
          </v-tooltip>
          
          <v-tooltip v-if="mode == 'show'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'editEvent'" v-if="mode == 'show'" icon flat slot="activator" @click="editEvent">
              <v-icon small color="white">edit</v-icon>
            </v-btn>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode != 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" v-if="mode != 'edit'" icon flat slot="activator" @click="$emit('close')">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode == 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'showEvent'" v-if="mode == 'edit'" icon flat slot="activator" @click="showEvent">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('cancel') }}</span>
          </v-tooltip>
        </v-layout>
      </v-toolbar>

      <v-layout wrap>
        <v-flex v-for="(state, i) in getItems.state" :key="state + i + 'button'" v-if="eventState[state.id]" :class="i > 0 ? 'pl-1' : 'pl-0'">
          <v-btn :data-testid="$options.name + 'v-btn' + 'onStateChange-state'" small text block depressed
            :disabled="eventState[state.id].disabled"
            :class="eventState[state.id].disabled ? 'light' : 'dark'"
            :color="eventState[state.id].active ? 'primary' : 'secondary'"
            @click="() => onStateChange(state)"
          >{{ $t(state.id) }}</v-btn>
        </v-flex>
      </v-layout>

      <scroll-area>
        <template slot="body">
          <!-- TEMPLATE FOR CREATE  -->
          <v-layout shrink ref="modal_layout" wrap>
            <v-flex xs6 px-0 >
              <v-layout column fill-height justify-start>
                <v-flex v-for="(field, name) in getFields" :key="field + name" v-if="field.show == 'true'" px-1 pb-1>
                  <v-layout shrink v-if="field.type != 'json'" px-2>
                    <v-flex xs4 shrink px-0 pb-2>               
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >                  
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 shrink px-0 pb-2>
                      <v-text-field
                        v-if="field.place != 'head' && field.show == 'true' && (field.type == 'text' || field.type == 'integer' || field.type == 'timestamp'  || field.type == 'TIMESTAMP WITH TIME ZONE')"
                        :data-testid="$options.name + 'v-text-field' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        outline
                        :readonly="field.readonly"
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-select
                        v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum')"
                        v-model="model.obj[field.name]"
                        :data-testid="$options.name + '__' + field.type + '__select-field__' + field.name"
                        light
                        :readonly="field.readonly"
                        :disabled="field.readonly"
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        :rules="field.required ? [value => !!value || $t('field must be filled')] : []"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        :clearable="!field.readonly"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex shrink v-for="(field, name) in getFields" :key="'boolean' + name" v-if="field.show == 'true' && field.type == 'boolean'" px-1>
                  <v-checkbox :data-testid="$options.name + 'v-checkbox' + field.name" small light color="secondary" v-model="model.obj[field.name]">
                    <template v-slot:label>
                      <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                      <span class="black--text" v-else>{{$t(field.name)}}</span>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 px-0 >
              <file-list
                :files="getFiles"
                :data="getData"
                :editable="false"
                :showDescription="false"
                @upload="(payload) => onFileAdd(payload)"
                @delete="(payload) => onFileDelete(payload)"
              />
            </v-flex>
          </v-layout>

          <v-flex v-for="(field, name) in getFields" :key="field + name + 'json'" v-if="field.type == 'json'" :style="'position: relative;'">
            <v-flex v-if="field.type == 'json' && model.obj[field.name]" shrink px-2>
              <span v-if="field.type == 'json' && model.obj[field.name]" :class="!field.readonly ? 'subheading primary--text' : 'subheading'">{{$t(field.name)}}</span>
            </v-flex>
            <vue-editor
              v-if="field.type == 'json' && model.obj[field.name]" 
              :id="field.name"
              :disabled = "field.readonly"
              v-model="model.obj[field.name].data"
              :customModules="customModulesForEditor"
              :editor-toolbar="customToolbar"
              :editorOptions="editorSettings"
              class="editor"
              @ready="(payload) => prepareEditor(payload, field.name)"
            >
            </vue-editor>
          </v-flex>
        </template>
      </scroll-area>
    </v-layout>

    <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show">
      <form-file-import
        :newFiles="dialog.upload.files"
        :edit="filesEdit"
        :files="filesEdit ? getFiles : []"
        :activeObj="getData"
        @update="() => onUpdate()"
        @close="onFileImportClose()"
        @delete="(payload) => onFileDelete(payload)"
      />
    </v-dialog>
  </v-container>
</template>

<script>

import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import fileList from '@/nms/components/partials/file-list.vue'
import uuidv4 from 'uuid/v4'
import { mapGetters } from 'vuex'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import { VueEditor } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

export default {

  name: 'EVENT_MODAL',

  components: {
    loadingCircle,
    scrollArea,
    fileList,
    VueEditor,
    FormFileImport
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    },

    parentActions: {
      type: Object,
      default: () => ({})
    },
  },

  data: () => ({

    loader: false,
    mode: 'show', 
    eventData: null,
    meta: {},
    eventState: {
      new_event: {
        active: false,
        disabled: true,
      },
      read_event: {
        active: false,
        disabled: true,
      },
      archived_event: {
        active: false,
        disabled: true,
      },
      deleted_event: {
        active: false,
        disabled: true,
      },
    },
    dialog: {
      state: {
        show: false,
        state: null
      },
      upload: {
        show: false,
        files: [],
      },
    },
    model: {
      fields: {},
      items: {},
      obj: {},
    },
    files: [],
    filesEdit: false,
    customModulesForEditor: [
      { alias: "imageDrop", module: ImageDrop },
      { alias: "imageResize", module: ImageResize }
    ],
    customToolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}],      // superscript/subscript
      // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }],          // dropdown with defaults from theme
      // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ 'align': [] }],

      ['clean']
    ],
    editorSettings: {
      modules: {
        imageDrop: true,
        imageResize: {}
      }
    }
  }),

  computed: {
    getData: function () {
      return this.eventData
    },
    getFields: function () {
      return this.model.fields
    },
    getItems: function () {
      return this.model.items
    },
    getFiles: function () {
      return this.files
    },
    ...mapGetters(['getCurrentUser']),
  },

  watch: {
    'data': {
      handler: function (newVal) {
        console.log('WATCH', this.$options.name, 'data', newVal)
        if(newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created () {
    console.log('WATCH', this.$options.name, 'created', 'data', this.data)
    if(!this.eventData) {
      this.eventData = this.$merge({}, this.data)
    }
    this.setup()
  },

  mounted () {},

  updated () {
    this.prepareEditor()
  },

  beforeDestroy () {},

  methods: {
    setup: async function () {
      await this.checkMode()
      this.reset()
      console.log(this.$options.name, 'setup', 'data', this.eventData)
      await this.loadMeta(this.$options.name)
      this.loadFiles()   
    },

    checkMode: async function () {
      if(!this.eventData.cls || this.eventData.cls != 'event') {
        this.mode = 'create'
      }
    },

    loadMeta: async function (caller) {
      try {
        this.meta = await this.$loadMeta(this.getData)
        console.log(this.$options.name, 'loadMeta', 'caller', caller, 'this.meta', this.meta)
        if(this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          await this.prepareData()
        }
      }
      catch(error) {
        console.error('CATCH', this.$options.name, 'loadMeta', 'error', err)
      }
    },

    prepareData: async function () {
      try {
        let fields = Object.keys(this.model.fields)
        fields.forEach(name => {

          if(this.mode == 'create') {
            this.$set(this.model.fields[name], 'readonly', false)
            if(name == 'object_id') {
              this.$set(this.model.fields[name], 'value', this.eventData.$id)
              this.$set(this.model.obj, [name], this.eventData.$id)
              this.$set(this.model.fields[name], 'readonly', true)
            }
            if(name == 'name') {
              let uid = uuidv4()
              this.$set(this.model.fields[name], 'value', "event_" + uid)
              this.$set(this.model.obj, [name], "event_" + uid)
            }
            if(name == 'state') {
              this.$set(this.model.fields[name], 'value', "new_event")
              this.$set(this.model.obj, [name], "new_event")
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
              this.eventState.new_event.active = true
              this.eventState.new_event.disabled = false   

            }
            if(name == 'last_update_user') {
              this.$set(this.model.fields[name], 'value', this.getCurrentUser.login)
              this.$set(this.model.obj, [name], this.getCurrentUser.login)
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
            if(this.model.fields[name].type == 'json') {
              this.$set(this.model.obj, [name], {})
              this.$set(this.model.obj[name], 'data', '')
            }
            if(this.model.fields[name].type == 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', this.moment().format('DD.MM.YYYY HH:mm'))              
              this.$set(this.model.obj, [name], this.moment())
              this.$set(this.model.fields[name], 'readonly', true)
              this.$set(this.model.fields[name], 'show', false)
            }   
            if(name == 'template') {
              this.$set(this.model.fields[name], 'value', "maintenance")
              this.$set(this.model.obj, [name], "maintenance")
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
          }

          if(this.mode == 'edit') {           
            this.$set(this.model.fields[name], 'value', this.eventData[name])
            this.$set(this.model.obj, [name], this.eventData[name])
            if(this.model.fields[name].type == 'timestamp' || this.model.fields[name].type == 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', this.moment(this.eventData[name]).format('DD.MM.YYYY HH:mm'))
              this.$set(this.model.obj, [name], this.eventData[name])
            }
            if(name == 'last_update_user') {
              this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
            } 
            if(name == 'last_update_date') {
              this.$set(this.model.obj, 'last_update_date', this.moment())
            }             
            if(name == 'state') {
              this.$set(this.model.fields[name], 'readonly', false)
              this.$set(this.model.fields[name], 'show', false)
              if(this.eventData[name]) {
                this.$set(this.eventState[this.eventData[name]], 'active', true)
                this.$set(this.eventState[this.eventData[name]], 'disabled', false)
                if(this.eventData[name] == 'read_event') {
                  this.$set(this.eventState.archived_event, 'active', false)
                  this.$set(this.eventState.archived_event, 'disabled', false)
                  this.$set(this.eventState.deleted_event, 'active', false)
                  this.$set(this.eventState.deleted_event, 'disabled', false)
                }
                if(this.eventData[name] == 'archived_event') {
                  this.$set(this.eventState.read_event, 'active', false)
                  this.$set(this.eventState.read_event, 'disabled', false)
                  this.$set(this.eventState.deleted_event, 'active', false)
                  this.$set(this.eventState.deleted_event, 'disabled', false)
                }
                if(this.eventData[name] == 'deleted_event') {
                  this.$set(this.eventState.read_event, 'active', false)
                  this.$set(this.eventState.read_event, 'disabled', false)
                  this.$set(this.eventState.archived_event, 'active', false)
                  this.$set(this.eventState.archived_event, 'disabled', false)
                }
              }
            }            
            if(name == 'state' && this.eventData[name] == 'new_event') {
              this.$set(this.model.obj, [name], 'read_event')
              this.$set(this.model.obj, 'last_update_date', this.moment())
              this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
              this.$set(this.model.fields.last_update_date, 'value', this.moment().format('DD.MM.YYYY HH:mm'))
              this.updateEvent(['state', 'last_update_date', 'last_update_user'])
            }
            if(name == 'template') {
              this.$set(this.model.fields[name], 'value', "maintenance")
              this.$set(this.model.obj, [name], "maintenance")
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }   
          } 

          if(this.mode == 'show') {
            this.$set(this.model.fields[name], 'value', this.eventData[name])
            this.$set(this.model.fields[name], 'readonly', true)
            this.$set(this.model.obj, [name], this.eventData[name])
            if(this.model.fields[name].type == 'timestamp' || this.model.fields[name].type == 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', this.moment(this.eventData[name]).format('DD.MM.YYYY HH:mm'))
              this.$set(this.model.obj, [name], this.eventData[name])
            }           
            if(name == 'last_update_user') {
              this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
            } 
            if(name == 'last_update_date') {
              this.$set(this.model.obj, 'last_update_date', this.moment())
            }             
            if(name == 'state' && this.eventData[name]) {
              if(this.eventData[name] == 'new_event') {
                this.$set(this.model.fields[name], 'show', false)
                this.$set(this.model.obj, [name], 'read_event')
                this.$set(this.model.obj, 'last_update_date', this.moment())
                this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
                this.$set(this.model.fields.last_update_date, 'value', this.moment().format('DD.MM.YYYY HH:mm'))
                this.updateEvent(['state', 'last_update_date', 'last_update_user'])
              }
              this.$set(this.eventState[this.eventData[name]], 'active', true)
              this.$set(this.eventState[this.eventData[name]], 'disabled', false)
            }
            if(name == 'template') {
              this.$set(this.model.fields[name], 'value', "maintenance")
              this.$set(this.model.obj, [name], "maintenance")
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
          }
        })
        console.log(this.$options.name, 'prepareData', 'this.model.fields', this.model.fields)
        console.log(this.$options.name, 'prepareData', 'this.model.obj', this.model.obj)
        console.log(this.$options.name, 'prepareData', 'this.model.items', this.model.items)
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'prepareData', 'error', err)
      }
    },

    prepareEditor: function (e, id) {
      // console.log(this.$options.name, 'testReady', 'e', e)
      // console.log(this.$options.name, 'prepareEditor', 'this', this)
      let wrapperHeight = this.$refs['barWrapper'].clientHeight
      let layoutHeight = this.$refs['modal_layout'].clientHeight
      // console.log(this.$options.name, 'prepareEditor', 'wrapperHeight', wrapperHeight)
      // console.log(this.$options.name, 'prepareEditor', 'layoutHeight', layoutHeight)
      // modal_layout
      let byid = document.getElementById(id)
      let int
      if(byid) {
        int = byid.querySelector(".ql-editor");
        // int.style['min-height'] = '200px'
        int.style['max-height'] = '120px'
        // int.style['min-height'] = this.$parent.$el.clientHeight - this.$refs['modal_layout'].clientHeight + 'px'
        // int.style['min-height'] = this.$root.$el.clientHeight * .6 * .55 + 'px'
        // int.style['min-height'] = wrapperHeight - layoutHeight + 'px'
        // int.style['height'] = '336px'
        // int.style['height'] = this.$parent.$el.clientHeight - this.$refs['modal_layout'].clientHeight + 'px'
        // int.style['height'] = this.$root.$el.clientHeight * .6 * .55 + 'px'
        // int.style['height'] = wrapperHeight - layoutHeight + 'px'
        int.style['min-height'] = 'auto'
        int.style['font-size'] = '12px'
        int.style['line-height'] = 1
        // int.style['background-color'] = 'red'
      }
    },

    loadFiles: async function () {
      try {
        if(this.eventData.cls != 'event') return
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.eventData.$id)
        console.log(this.$options.name, 'loadFiles', 'this.files', this.files)
        this.setLoader('loadFiles', false)
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    onFileAdd: function (payload) {
      console.log(this.$options.name, 'onFileAdd', 'payload', payload)
      Object.keys(payload).map(index => {
        this.dialog.upload.files.push(payload[index])
      })
      this.dialog.upload.show = true
    },

    onFileDelete: async function (id) {
      this.files.forEach((file, index) => {
        if(file.id == id) {
          this.files.splice(index, 1)
        }
      })
      try{
        let d = await this.$bridge.deleteDocument(id)
        if(d) {
          await this.updateEvent(['last_update_date', 'last_update_user'])
          this.loadFiles()
        }   
      }
      catch(err) {
        console.error('CATCH', this.$options.name, 'onFileDelete', err)
      }
    },

    onStateChange: async function (state) {
      this.$set(this.dialog.state, 'state', state.id)
      this.$dialog.confirm({
        // text: "Удалить " + this.getData.name + '?',
        text: "Вы действительно хотите поменять статус события " + this.eventData.users_name + '?',
        // text: "Вы действительно хотите поменять статус события " + this.getData.name + '?',
        title: "Изменение статуса",
        actions: {
          false: {
            text: "Отмена",
            handle: async () => {
              try {
                this.$set(this.dialog.state, 'state', null)
              }
              catch(err) {
                console.error('CATCH',this.$options.name, 'onStateChange', err)
                this.$errorHandler(err)
              }
            }
          },
          true: {
            color: "red",
            text: "Да",
            handle: async () => {
              try {
                this.$set(this.model.obj, 'state', this.dialog.state.state)
                this.$set(this.model.obj, 'last_update_date', this.moment())
                this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
                await this.updateEvent()
              }
              catch(err) {
                console.error('CATCH',this.$options.name, 'onStateChange', err)
                this.$errorHandler(err)
              }
            }
          }
        }
      })
    },
    
    changeState: async function () {
      this.$set(this.model.obj, 'state', this.dialog.state.state)
      this.$set(this.model.obj, 'last_update_date', this.moment())
      this.$set(this.model.obj, 'last_update_user', this.getCurrentUser.login)
      await this.updateEvent()
    },

    createEvent: async function () {
      console.log(this.$options.name, 'createEvent', 'start')
      let data$ = {}
      data$.type = 'event'
      let fields = Object.keys(this.model.obj)
      fields.forEach(field => {
          data$[field] = this.model.obj[field]   
      })
      console.log(this.$options.name, 'createEvent', 'data$', data$)

      let validate = true
      Object.keys(this.model.fields).forEach(field => {
        let f = this.model.fields[field]
        if(f.required && f.required != 'false' && f.show && f.show != 'false') {
          if(!this.model.obj[field]) {
            console.log(this.$options.name, 'changeState field', field)
            validate = false
          }
        }
      })

      if(!validate) {
        console.log(this.$options.name, 'changeState validate', validate)
        this.$snotify.warning('Обязательные поля не заполнены!', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        return
      }

      try {
        let events = await this.$bridge.getByPath('/events')
        let event = await events.createChild('event', data$)
        if(event) {
          console.log(this.$options.name, 'createEvent', 'event', event)
          if(this.files.length) {
            console.log(this.$options.name, 'createEvent', 'files', this.files)
            let $_data = new FormData
            this.files.forEach((file, index) => {
              $_data.append('files', file)
            })
            let updatedEvent = await event.update($_data)
            if(updatedEvent) {           
              console.log(this.$options.name, 'createEvent', 'updatedEvent', updatedEvent)
            }                     
          }
          await this.parentActions.setup()
          this.$emit('close')               
        }       
      }
      catch(err){
        console.error('CATCH',this.$options.name, 'createEvent', err)
        this.$errorHandler(err)
      }
    },

    updateEvent: async function (fields_) {
      console.log(this.$options.name, 'updateEvent', 'start')
      console.log(this.$options.name, 'updateEvent', 'fields_', fields_)
      if(this.eventData.cls != 'event') return
      let data$ = {}
      if(Array.isArray(fields_) && fields_.length) {
        fields_.forEach(field_ => {
          data$[field_] = this.model.obj[field_]
        })
      } else {
        let fields = Object.keys(this.model.obj)
        fields.forEach(field => {
          data$[field] = this.model.obj[field]  
        })

        let validate = true
        Object.keys(this.model.fields).forEach(field => {
          let f = this.model.fields[field]
          if(f.required && f.required != 'false' && f.show && f.show != 'false') {
            if(!this.model.obj[field]) {
              console.log(this.$options.name, 'updateEvent field', field)
              validate = false
            }
          }
        })

        if(!validate) {
          console.log(this.$options.name, 'updateEvent validate', validate)
          this.$snotify.warning('Обязательные поля не заполнены!', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
          return
        }

      }
      console.log(this.$options.name, 'updateEvent', 'data$', data$)

      try {
        let event = this.eventData._cmdb_ ? this.eventData : await this.$bridge.getObjectById(this.eventData.$id)
        let updatedEvent = await event.update(data$)
        if(updatedEvent) { 
          let u = updatedEvent
          if(this.files.length) {
            let $_data = new FormData
            this.files.forEach((file, index) => {
              $_data.append('files', file)
            })
            u = await updatedEvent.update($_data)
          }    
          await this.parentActions.setup()
          this.eventData = u
          this.showEvent()
          console.log(this.$options.name, 'updateEvent', 'updatedEvent', updatedEvent)
        }    
      }
      catch(err){
        console.error('CATCH',this.$options.name, 'updateEvent', err)
        this.$errorHandler(err)
      }
    },
    
    editEvent: async function () {     
      this.mode = 'edit'
      this.setup()
    },
    
    showEvent: async function () {     
      this.mode = 'show'
      this.setup()
    },

    onEditorChange: async function (delta, oldDelta, source) {     
      console.log(this.$options.name, 'onEditorChange', 'delta', delta)
      console.log(this.$options.name, 'onEditorChange', 'oldDelta', oldDelta)
      console.log(this.$options.name, 'onEditorChange', 'source', source)
    },

    onFileImportClose: function () {
      this.dialog.upload.show = false
      this.filesEdit = false
      this.dialog.upload.files = []
    },

    onUpdate: function () {
      setTimeout(() => this.loadFiles(), 1000)
    },

    setLoader: function(name, status) {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset: function () {
      this.loader = false
      this.meta = {}
      this.model = {
        fields: {},
        items: {},
        obj: {}
      }
      this.eventState = {
      new_event: {
        active: false,
        disabled: true,
      },
      read_event: {
        active: false,
        disabled: true,
      },
      archived_event: {
        active: false,
        disabled: true,
      },
      deleted_event: {
        active: false,
        disabled: true,
      }
    }
    this.dialog = {
      state: {
        show: false,
        state: null
      },
      upload: {
        show: false,
        files: [],
      },
    }
      this.files = []
    }

  }

}
</script>

<style scoped>
</style>
